import generateSingleDocument from "common/document/generate_single_document";
import {
  getAnalysingTimeRemaining,
  getClassifyingTimeRemaining as getClassifyingTimeRemainingBase,
} from "common/utils/document_time_remaining";

const getParsingProgressPercent = ({
  parse_state: parseState,
  load_state: loadState,
  analyser_progress: analyserProgress,
}) => {
  if (loadState === 4) {
    return 0;
  }
  if (loadState === 0) {
    if (!parseState || (parseState >= 200 && parseState <= 299)) {
      return 0;
    }
    if (parseState >= 300 && parseState <= 399) {
      return 10;
    }
    if (parseState >= 400 && parseState <= 499) {
      return 14;
    }
    if (parseState >= 500 && parseState <= 599) {
      return 20;
    }
    return 0;
  }
  if (loadState === 7) {
    if (analyserProgress && analyserProgress > 0) {
      return 24 + Math.floor(Math.min(analyserProgress, 1) * 100 - 24);
    }
    return 24;
  }
  if (loadState === 8) {
    return 98;
  }
};

const getClassifyingProgressPercent = ({
  classification_start: classificationStart,
  clausepart_load_count: clausepartLoadCount,
  clausepart_load_total: clausepartLoadTotal,
}) => {
  if (!classificationStart || clausepartLoadCount === 0) {
    return 0;
  }
  if (clausepartLoadCount === clausepartLoadTotal) {
    return 100;
  }
  return Math.round((clausepartLoadCount * 100 * 0.99) / clausepartLoadTotal);
};

const getParsingTimeRemaining = ({
  load_state: loadState,
  text_length: textLength,
  creation_date: creationDate,
}) => {
  if (loadState !== 0 && loadState !== 7) {
    return null;
  }
  return getAnalysingTimeRemaining(textLength, creationDate);
};

const getClassifyingTimeRemaining = ({
  classification_start: classificationStart,
  clausepart_last_edited: clausepartLastEdited,
  clausepart_load_count: clausepartLoadCount,
  clausepart_load_total: clausepartLoadTotal,
  clauses_llm_time_estimate: clausesLlmTimeEstimate,
}) => {
  if (!classificationStart) {
    return null;
  }
  return getClassifyingTimeRemainingBase(
    clausepartLastEdited,
    classificationStart,
    clausepartLoadCount,
    clausepartLoadTotal,
    clausesLlmTimeEstimate,
  );
};

const STAGE_PROGRESS_FNS = {
  parsing: getParsingProgressPercent,
  classifying: getClassifyingProgressPercent,
};

const STAGE_TIME_FNS = {
  parsing: getParsingTimeRemaining,
  classifying: getClassifyingTimeRemaining,
};

export const computeProgress = (document, stageName) => {
  const getProgressFn = STAGE_PROGRESS_FNS[stageName];
  const fileCount = document.concat_filenames?.length ?? 1;
  if (fileCount === 1) {
    return getProgressFn(generateSingleDocument(document, 0)) ?? 0;
  }
  let totalProgress = 0;
  let totalLength = 0;
  document.concat_filenames.forEach((_, index) => {
    const indexDoc = generateSingleDocument(document, index);
    const progress = getProgressFn(indexDoc) ?? 0;
    const length = indexDoc.text_length ?? 0;
    totalProgress =
      (totalProgress * totalLength + progress * length) /
      (totalLength + length);
    totalLength += length;
  });
  return totalProgress;
};

export const computeTimeRemaining = (document, stageName) => {
  const getTimeRemainingFn = STAGE_TIME_FNS[stageName];
  const fileCount = document.concat_filenames?.length ?? 1;
  if (fileCount === 1) {
    return getTimeRemainingFn(generateSingleDocument(document, 0));
  }
  let maxTimeRemaining = 0;
  document.concat_filenames.forEach((_, index) => {
    const indexDoc = generateSingleDocument(document, index);
    maxTimeRemaining = Math.max(
      maxTimeRemaining,
      getTimeRemainingFn(indexDoc) ?? 0,
    );
  });
  return maxTimeRemaining;
};
